module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "homepage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search"
    }
  }, [_c('h2', [_vm._v("Rechercher une recette")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "sort"
    }
  }, [_c('div', {
    staticClass: "radio-group"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.mealType), function(option) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtersData.mealType),
        expression: "filtersData.mealType"
      }],
      attrs: {
        "type": "radio",
        "name": "mealType",
        "id": 'mealType-' + option.value
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.filtersData.mealType, option.value)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.filtersData, "mealType", option.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'mealType-' + option.value
      }
    }, [_vm._v(_vm._s(option.text))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('city.difficulty')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.difficulty), function(option) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtersData.difficulty),
        expression: "filtersData.difficulty"
      }],
      attrs: {
        "type": "radio",
        "name": "difficulty",
        "id": 'difficulty-' + option.value
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.filtersData.difficulty, option.value)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.filtersData, "difficulty", option.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'difficulty-' + option.value
      }
    }, [_vm._v(_vm._s(option.text))])])
  })], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Envoyer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.redirect($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "trends"
    }
  }, [_c('h2', [_vm._v("Tendances")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "recipes"
  }, _vm._l((_vm.highlight), function(recipe) {
    return _c('div', {
      staticClass: "recipe"
    }, [_c('img', {
      attrs: {
        "src": _vm.$options.filters.formatUrl(recipe.image.url),
        "alt": recipe.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('h3', [_vm._v(_vm._s(recipe.name.split(' ')[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": {
          name: 'recipe',
          params: {
            city: _vm.city.url,
            recipe: recipe.url
          }
        }
      }
    }, [_vm._v("\n            en savoir +\n          ")])], 1)])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "display"
    }
  }, [_c('h2', [_vm._v("Recettes à l'affiche")]), _vm._v(" "), _c('ul', {
    staticClass: "recipes"
  }, _vm._l((_vm.recipes), function(recipe) {
    return _c('li', {
      staticClass: "recipe"
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      attrs: {
        "src": _vm.$options.filters.formatUrl(recipe.image.url),
        "alt": recipe.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('h3', [_vm._v(_vm._s(recipe.name.split(' ')[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": {
          name: 'recipe',
          params: {
            city: _vm.city.url,
            recipe: recipe.url
          }
        }
      }
    }, [_vm._v("\n            en savoir +\n          ")])], 1)])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bread",
      "data-parallax": "2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plate"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hola"
    }
  }, [_c('div', {
    staticClass: "main-image"
  }), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Bienvenue sur TradFood !")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n          Trad’ Food est une plateforme en ligne ouverte à tous.\n          Elle vous permet, que vous soyez locaux ou touristes, de découvrir ou de redécouvrir, les recettes les plus emblématiques du terroir bordelais.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Avec un panel de recettes triées par difficultés, saisons, et types de plats, le site vous propose de réaliser par vous même les recettes bordelaises qui font la richesse gastronomique de la région bordelaise.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Découvrez nos dernières recettes tendances"), _c('br'), _vm._v(" et savourez-les en apprenant à les cuisiner vous-même !")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a379bd3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 65
// module chunks = 1